import { createSelector } from 'reselect';

import { getSelectedWarehouse, getWarehouseById } from 'reducers/warehouses';
import { getSetting } from 'reducers/configs/settings';
import { getSelectedPos } from 'reducers/PointsOfSale';

export const getActivePricelistIDsForPOS = createSelector(
  state => getWarehouseById((getSelectedPos(state) || {}).warehouseID)(state),
  state => getSelectedWarehouse(state),
  state => getSetting('pos_allow_selling_only_from_pricelist1')(state),
  (warehouse, warehouseFallback, priceListOverride) => {
    // If network connection is slow warehouse might not be fetched by the time this code runs
    // in such case use warehouse from local storage instead
    const wh = warehouse ?? warehouseFallback;
    if (!wh) return [];
    const rules = [
      wh.pricelistID,
      wh.pricelistID2,
      wh.pricelistID3,
      wh.pricelistID4,
      wh.pricelistID5,
    ].filter(a => Number(a) !== 0);
    return priceListOverride === 1 ? rules.slice(0, 1) : rules;
  },
);
